import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import homeHero from './../assets/images/home_hero.png';
import Hero from './ui/Hero.js';
import { OutlineButton } from './ui/MyButton';
import image1 from '../assets/images/image1.png';
import commaImg from '../assets/images/inverted_comma.svg';
import { services, whychoose } from '../constant.js';
import image2 from '../assets/images/image2.png';
import logo from '../assets/images/libcloud_logo.svg';
import ScrollAnimation from 'react-animate-on-scroll';
import cloudImg from '../assets/images/cloud.svg';

const HomePage = () => {
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className='animated_card'>
            <style>
                {`
                .my-button:hover {
                    background: var(--primary-gradient-100);
                    color: #FFF;
                }
                `}
            </style>
            <Hero img={homeHero}>
                <h2 style={{ color: "var(--text-color)" }}>Streamline Your Library <br />Management With <br />
                    <span
                        style={{
                            // background: "var(--primary-gradient-100)",
                            // backgroundClip: "text",
                            // WebkitTextFillColor: "transparent"
                            background: "var(--primary-gradient-100)",
                            backgroundClip: "text",
                            WebkitBackgroundClip: "text",
                            color: "var(--text-color)",
                            WebkitTextFillColor: "transparent"
                        }}>
                        LibCloud</span></h2>
            </Hero>
            <div className={`${isMobile ? "sizedbox" : ""} mt-5 row g-2 gap-5 align-items-center`}>
                <ScrollAnimation animateIn='fadeInLeftBig' className='col-12 col-md-5'
                    animateOut='fadeOutLeftBig' duration="2">
                    <div>
                        <img src={image1} alt='about us' style={{ width: "100%", objectFit: "cover", borderRadius: isMobile ? "30px" : "0 30px 30px 0 ", height: "auto", maxHeight: "480px" }}></img>
                    </div>
                </ScrollAnimation>
                <ScrollAnimation animateIn='fadeInRightBig' className='col-12 col-md-5'
                    animateOut='fadeOutRightBig' duration="2">
                    <div>
                        <p className='py-1 px-4 rounded-3' style={{ backgroundColor: "#F4F7FE", color: "var(--text-color)", fontSize: "18px", fontWeight: "400", width: "fit-content" }}>
                            About Us
                        </p>
                        <h2 style={{ color: "var(--text-color)", width: "75%", marginTop: "10px" }}>
                            <img src={commaImg} alt='comma' className='me-2'></img>
                            Your Trusted Technology Partner</h2>
                        <p style={{ color: "var(--text-color)", fontSize: "18px", fontWeight: "400", lineHeight: "24px", marginTop: "1rem" }}>
                            LibCloud is your reliable partner for managing Koha Library Management Software and its mobile application. We specialize in expert setup and cloud-based support for Koha—a powerful and sophisticated library management system.<br /><br />
                            Our solutions include pre-installed, ready-to-use Koha software and mobile applications compatible with both Android and iOS, perfectly tailored to meet the needs of our business associates. Partner with LibCloud to simplify your technology needs and focus on achieving your business goals.
                        </p>
                        <OutlineButton onClick={() => { navigate("/about") }} />
                    </div>
                </ScrollAnimation>
            </div>

            <div>
                <div style={{ padding: "25px 0", backgroundImage: "linear-gradient(0, white 0 50%, #EBF1FD 50% 100%)", marginTop: "50px", alignItems: "center", textAlign: "center", }}>
                    <h2 style={{ color: "var(--text-color)" }}>Our&nbsp;
                        <span
                            style={{
                                background: "var(--primary-gradient-100)",
                                backgroundClip: "text",
                                WebkitTextFillColor: "transparent"
                            }}>
                            Services</span></h2>
                    <ScrollAnimation animateIn='fadeInUp' duration="2"
                        animateOut='fadeOut'>
                        <div className='sizedbox w-100 row g-3 gap-3 justify-content-center align-items-stretch'>
                            {
                                services.map((item, index) => (
                                    <div
                                        className='col-12 col-md-5  d-flex flex-column text-start'
                                        style={{
                                            boxShadow: "0px 4px 5px 0px #00000033",
                                            backgroundColor: "#FFF7FD",
                                            padding: "20px",
                                            maxWidth: "600px",
                                            borderRadius: "20px"
                                        }}
                                        key={index}
                                    >
                                        <img src={item.image} alt={item.title} style={{ width: "100%" }} />
                                        <h4 className='mt-4' style={{ fontSize: "30px", fontWeight: "400", color: "var(--text-color)" }}>
                                            {item.title}
                                        </h4>
                                        <p className='mt-4 mb-3' style={{ fontSize: "18px", fontWeight: "400", color: "var(--text-color)", textAlign: "justify" }}>
                                            {item.desc}
                                        </p>
                                        <div className='mx-auto mt-auto' style={{ width: "fit-content" }}>
                                            <OutlineButton btnbackground='#FFF7FD' onClick={() => { navigate(`${item.path}`) }} />
                                        </div>
                                    </div>
                                ))
                            }
                        </div>

                    </ScrollAnimation>
                </div>
            </div>

            <ScrollAnimation animateIn='fadeInRightBig' duration="2"
                animateOut='fadeOutRightBig'>
                <div className='d-flex justify-content-end w-100 z-0'
                    style={{ marginBottom: "-200px" }}>
                    <img src={cloudImg} alt='Cloud'></img>
                </div>
            </ScrollAnimation>
            <ScrollAnimation animateIn='fadeInLeftBig' duration="2"
                animateOut='fadeOutRightBig'>
                <div className='sizedbox mt-5 z-10'>
                    <h2 style={{ color: "var(--text-color)" }}>Why choose&nbsp;
                        <span
                            style={{
                                background: "var(--primary-gradient-100)",
                                backgroundClip: "text",
                                WebkitTextFillColor: "transparent"
                            }}>
                            LibCloud</span>?</h2>
                    <div className='mt-3 row g-2'>
                        {
                            whychoose.map((item, index) => (
                                <div className='col-12 col-md-3 text-center p-2 align-items-stretch' >
                                    <div className='bg-white'
                                        style={{
                                            boxShadow: "0px 4px 5px 0px #00000033",
                                            padding: "20px",
                                            borderRadius: "15px",
                                            alignItems: "center",
                                            height: "100%"
                                        }}
                                    >
                                        <img className='mt-2' src={item.image} alt={item.title}></img>
                                        <h4 className='mt-3 text-start' style={{ fontSize: "30px", fontWeight: "400", color: "var(--text-color)" }}>
                                            {item.title}
                                        </h4>
                                        <p className='mt-3 mb-3' style={{ fontSize: "18px", fontWeight: "400", color: "var(--text-color)", textAlign: "justify" }}>
                                            {item.desc}
                                        </p>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </ScrollAnimation>
            <Hero className='mt-5' img={image2} background='#eff3fe'>
                <img src={logo} alt='Libcloud'></img>
                <h2 style={{ color: "var(--text-color)", marginBottom: "20px" }}>Your Koha Implementation Specialists, Making Libraries Thrive!</h2>
            </Hero>
        </div >
    );
}

export default HomePage;